import { type FastshiftMigrationPlanProduct } from '@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';

import {
	FastshiftProductIcon,
	type FastshiftProductVariant,
} from '@/common/fastshift-product-icon/src/fastshift-product-icon';

import { getMigrationPlanProductMessage } from './migration-plans-display-utils';

const styles = cssMap({
	siteDetails: {
		minWidth: '0',
	},
});

export const MigrationPlanSiteDetails = ({
	product,
	baseUrl,
	variant,
}: {
	product: FastshiftMigrationPlanProduct | null;
	baseUrl: string;
	variant: FastshiftProductVariant;
}) => {
	const { formatMessage } = useIntl();

	return (
		<Inline space="space.100" alignBlock="center">
			<FastshiftProductIcon productName={product} variant={variant} />
			<Stack space="space.025" xcss={styles.siteDetails}>
				<Text maxLines={1}>{formatMessage(getMigrationPlanProductMessage(product))}</Text>
				<Text color="color.text.subtle" maxLines={1}>
					{baseUrl}
				</Text>
			</Stack>
		</Inline>
	);
};
